import { Box, Divider, Typography } from "@mui/material"
import type { FC } from "react"
import { useCallback } from "react"
import type { Control } from "react-hook-form"
import { Controller } from "react-hook-form"

import { COST_BREAKDOWN_FILTER_OPTIONS } from "../../constants"

import { AerosCheckbox } from "@/components/UiKit"
import type { GoodsReceiptFilterFormValues } from "@/screens/WarehouseReceiving/types"

interface CostBreakdownFilterFormValues extends GoodsReceiptFilterFormValues {
  isProductCostCompleted?: boolean[]
}

interface CostBreakdownFilterProps {
  control: Control<CostBreakdownFilterFormValues>
  selectedValues?: boolean[]
  onChange: (isProductCostCompleted?: boolean[]) => void
}

export const CostBreakdownFilter: FC<CostBreakdownFilterProps> = ({ control, selectedValues, onChange }) => {
  const handleCheckboxChange = useCallback(
    (optionValue: boolean, field: any) => (checked: boolean) => {
      const currentValues = field.value || []
      const newValues = checked
        ? [...currentValues, optionValue]
        : currentValues.filter((val: boolean) => val !== optionValue)

      field.onChange(newValues)
      onChange(newValues)
    },
    [onChange]
  )

  return (
    <Box className='flex flex-col'>
      <Typography variant='subtitle1' fontWeight={700} className='px-4 py-1.5 text-gray-700'>
        Product Cost Completed
      </Typography>
      <Divider />
      <Box className='flex flex-col px-8 py-4'>
        <Controller
          name='isProductCostCompleted'
          control={control}
          render={({ field }) => (
            <>
              {COST_BREAKDOWN_FILTER_OPTIONS.map((option) => (
                <AerosCheckbox
                  key={String(option.value)}
                  checked={selectedValues?.includes(option.value) ?? false}
                  onChange={handleCheckboxChange(option.value, field)}
                  label={option.label}
                />
              ))}
            </>
          )}
        />
      </Box>
    </Box>
  )
}
